export default {
    props: {
        checkboxesCheckChildren: {
            type: Boolean,
            kComposite: 'checkboxes.checkChildren'
        }, 
        checkboxesName: {
            type: String,
            kComposite: 'checkboxes.name'
        }, 
        checkboxesTemplate: {
            type: String | Function,
            kComposite: 'checkboxes.template'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-treeview-vue-wrapper/src/KendoTreeView/Checkboxes.js